"use strict";
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, upload, Flash) {
  $scope.doBulkUpload = function() {
    $scope.loading = true;
    upload({
      url: '/api/picture/bulkimport',
      method: 'POST',
      data: {}
    }).then(function(response) {
      var message = '<strong>Erfolgreich importiert!</strong>.';
      Flash.create('success', message, 5000, {}, true);
      $scope.loading = false;
    }, function(response) {
      var msg = "Unkown";
      if (hlp.isSet(response.data.message)) {
        msg = response.data.message;
      }
      var message = '<strong>Fehler beim importieren! (' + msg + ')</strong>.';
      Flash.create('danger', message, 0, {}, true);
      $scope.loading = false;
    });
  };
  var init = function() {}();
};
module.exports = controller;
